import Api from '../Api';

import { url } from './config';
import { CreditCompanyType } from './types';

const api = new Api<CreditCompanyType>(url);

export default api;
